import cx from 'classnames';

import type { TCommonTypographyProps } from './types';

export const getCommonClassName = ({
  strong,
  shadow,
  italic,
  color,
  className,
  align,
  textWrap,
  transform,
  ellipsis,
  underlineOnHover
}: Partial<TCommonTypographyProps>) => {
  return cx(
    { 'text-bold': strong },
    { 'text-italic': italic },
    { 'text-muted': color === 'muted' },
    { 'text-raiderio': color === 'raiderio' },
    { 'text-danger': color === 'danger' },
    { 'text-white': color === 'white' },
    { 'text-warn': color === 'warning' },
    { 'text-success': color === 'success' },
    { 'text-success--green': color === 'success-green' },
    { [`rio-text-shadow--${typeof shadow === 'string' ? shadow : 'medium'}`]: shadow },
    { [`slds-text-align--${align}`]: align },
    { 'text-pretty': textWrap === 'pretty' },
    { 'text-uppercase': transform === 'uppercase' },
    { 'text-ellipsis': ellipsis },
    { 'rio-text-underline--hover': underlineOnHover },
    className
  );
};
